import(/* webpackMode: "eager" */ "/Users/chorneiolha/Downloads/site-for-work/UK/src/app/page.tsx");
